module.exports = __webpack_public_path__ + "static/img/corefuntion1.e045b0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/corefuntion/corefuntion1.png
// module id = wdKj
// module chunks = 0